// extracted by css-extract-rspack-plugin
export default {"info_block":"sCpXG","infoBlock":"sCpXG"};